const CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL || "http://localhost:1337";

async function cmsGet(path) {
  const url = `${CMS_BASE_URL}${path}`;
  const response = await fetch(url, {
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`CMS request failed: ${response.status}`);
  }

  return response.json();
}

// Utility endpoint call for homepage content (Strapi)
export function getHomepageContent() {
  return cmsGet("/api/homepage?populate=*&publicationState=preview");
}

// Utility endpoint call for medical homepage content (Strapi)
export function getMedicalHomepageContent() {
  return cmsGet("/api/medical-homepage?populate=*&publicationState=preview");
}

// Generic utility for future pages/components
export function getCmsByPath(path) {
  return cmsGet(path);
}
